export const fieldsAddUser = [
  { name: "nombre", label: "Nombre" },
  { name: "userName", label: "Usuario" },
  { name: "perfil", label: "Perfil" },
  { name: "correo", label: "Correo" },
  { name: "lenguaje", label: "Lenguaje" },
  { name: "proyecto", label: "Proyectos" },
  { name: "cliente", label: "Clientes" },
  { name: "permisionario", label: "Permisionarios" },
  { name: "tipoTrabajo", label: "Tipos de Trabajo" },
  { name: "empresa", label: "Empresa" },
  { name: "permisos", label: "Permisos" },
];

export const fieldsAddProvider = [
  { name: "razonSocial", label: "Razón Social" },
  { name: "rfc", label: "RFC" },
  { name: "direccionFiscal", label: "Dirección Fiscal" },
];

export const fieldsAddProviderData = [
  { name: "estatus", label: "Estatus" },
  { name: "comentarios", label: "Comentarios" },
  { name: "cobertura", label: "Cobertura sin viáticos" },
  { name: "especialidades", label: "Especialidades" },
];

export const fieldsAddProviderContact = [
  { name: "nombre", label: "Nombre de Contacto" },
  { name: "apellidos", label: "Apellido de Contacto" },
  { name: "telefono", label: "Teléfono de Contacto" },
  { name: "email", label: "Email de Contacto" },
];

export const fieldsAddProviderBank = [
  { name: "institucionBancaria", label: "Nombre del Banco" },
  { name: "numCuenta", label: "Número de Cuenta" },
  { name: "clabeInterbancaria", label: "CLABE Interbancaria" },
  { name: "sucursal", label: "Sucursal" },
];

export const fieldsUploadUser = [
  { name: "nombre", label: "Nombre" },
  { name: "userName", label: "Usuario" },
  { name: "perfil", label: "Perfil" },
  { name: "correo", label: "Correo" },
];

export const fieldsAddInstallers = [
  { name: "nombre", label: "Nombre" },
  { name: "apellidos", label: "Apellido" },
  { name: "email", label: "Email" },
  { name: "telefono", label: "Telefono" },
  { name: "numGafete", label: "Numero de gafete" },
  { name: "rfc", label: "RFC" },
  { name: "perfilInstalador", label: "Perfil instalador" },
  { name: "comentarios", label: "Comentarios" },
];
